import { apiFetch } from "../api.js";

/**
 * Cards optimization API client — Phase 8 Session 3.
 *
 * Reads against the AccountsDomainFn Lambdalith's 3 cards endpoints.
 * No mutations in v1 — the curated reward table on the server is the
 * source of truth; user-edited overrides land Phase 11.
 */

export interface CardsOptimizationResponse {
  cards: Array<{
    account_id: string;
    account_name: string;
    institution: string;
    card_match: { card_id: string; name: string; annual_fee_cents: number };
    gross_annual_cents: number;
    net_annual_cents: number;
    breakeven_monthly_cents: number | null;
    breakeven_bonus_category: string | null;
    per_category: Array<{
      category: string;
      monthly_spend_cents: number;
      net_annual_cents: number;
    }>;
  }>;
  unmatched_accounts: Array<{
    account_id: string;
    account_name: string;
    institution: string;
  }>;
  as_of: string;
  is_stale: boolean;
}

export interface CardsRecommendationsResponse {
  category: string;
  monthly_spend_cents: number;
  ranked: Array<{
    card_id: string;
    issuer: string;
    name: string;
    annual_fee_cents: number;
    net_annual_cents: number;
    gross_annual_cents: number;
    effective_rate_bp: number;
    rationale: string;
  }>;
  as_of: string;
  is_stale: boolean;
}

export interface CardsBreakevenResponse {
  rows: Array<{
    card_id: string;
    issuer: string;
    name: string;
    annual_fee_cents: number;
    monthly_breakeven_cents: number | null;
    bonus_category: string | null;
    bonus_rate_bp: number | null;
  }>;
  as_of: string;
  is_stale: boolean;
}

export function getCardsOptimization(): Promise<CardsOptimizationResponse> {
  return apiFetch<CardsOptimizationResponse>(
    "/v1/accounts/cards/optimization",
  );
}

export function getCardsRecommendations(args: {
  category: string;
  monthly_spend_cents: number;
}): Promise<CardsRecommendationsResponse> {
  const params = new URLSearchParams({
    category: args.category,
    monthly_spend_cents: String(args.monthly_spend_cents),
  });
  return apiFetch<CardsRecommendationsResponse>(
    `/v1/accounts/cards/recommendations?${params.toString()}`,
  );
}

export function getCardsBreakeven(): Promise<CardsBreakevenResponse> {
  return apiFetch<CardsBreakevenResponse>("/v1/accounts/cards/breakeven");
}
